import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export interface CheckoutRequest {
  tier: string;
  isYearly: boolean;
}

export interface CheckoutResponse {
  checkout_url: string;
}

export interface PaymentPortalResponse {
  portal_url: string;
}

export const checkoutApi = createApi({
  reducerPath: 'checkoutApi',
  baseQuery: baseQuery(),
  tagTypes: ['Checkout'],
  endpoints: (builder) => ({
    createCheckoutSession: builder.mutation<CheckoutResponse, CheckoutRequest>({
      query: (checkoutData) => ({
        url: '/payment/checkout',
        method: 'GET',
        params: {
          tier: checkoutData.tier,
          yearly: checkoutData.isYearly
        }
      }),
      invalidatesTags: ['Checkout']
    }),
    createPaymentPortalSession: builder.mutation<PaymentPortalResponse, void>({
      query: () => ({
        url: '/payment/portal',
        method: 'GET'
      }),
      invalidatesTags: ['Checkout']
    })
  })
});

export const { useCreateCheckoutSessionMutation, useCreatePaymentPortalSessionMutation } = checkoutApi;
